export interface CalendarAppBaseText {
    applyPromoCodeButtonText: string;
    buyTicketCtaDefaultText: string;
    calendarAppHeading: string;
    calendarFiltersHeading: string;
    calendarLoadingLabel: string;
    categoryFilterLabelText: string;
    categorySelectAllDropdownOption: string;
    clearAllButtonText: string;
    emptyMonthMessaging: string;
    filterOpenButtonLabel: string;
    gridViewModeButtonText: string;
    listViewModeButtonText: string;
    loadMoreEventsButtonText: string;
    mainBody: string;
    monthDropdownDescriptionText: string;
    productionFilterLabelText: string;
    productionSelectAllDropdownOption: string;
    promoCodeDescriptionText: string;
    venueFilterLabelText: string;
    venueSelectAllDropdownOption: string;

    // NEW
    calendarOpenButtonLabel: string;
    shareButtonText: string;
    applyFiltersButtonText: string;
    closeDialogButtonText: string;
    calendarNavigationHeading: string;
    shareLinkCopiedTooltip: string;
    shareDateButtonText: string;
    previousMonthButtonText: string;
    nextMonthButtonText: string;
    todayButtonText: string;
    appliedPromoCodeHeading: string;
    removePromoCodeButtonText: string;
    scrollToTopButtonText: string;
    showShareButtons: boolean;
    souldOutText: string;
}

export const defaultBaseText: CalendarAppBaseText = {
    applyPromoCodeButtonText: 'Apply Code',
    buyTicketCtaDefaultText: 'Buy Tickets',
    calendarAppHeading: "Calendar",
    calendarFiltersHeading: "Calendar Filters",
    calendarLoadingLabel: "Calendar is loading",
    categoryFilterLabelText: 'Venue Specific Dropdown',
    categorySelectAllDropdownOption: 'Series/Genre',
    clearAllButtonText: "Clear All",
    emptyMonthMessaging: '<p>There are no events</p>',
    filterOpenButtonLabel: "Filters",
    gridViewModeButtonText: 'Grid View',
    listViewModeButtonText: 'List View',
    loadMoreEventsButtonText: 'Load More',
    mainBody: '',
    monthDropdownDescriptionText: "Select month",
    productionFilterLabelText: 'Performances',
    productionSelectAllDropdownOption: 'All Productions',
    promoCodeDescriptionText: "Enter promo code",
    venueFilterLabelText: 'Venue',
    venueSelectAllDropdownOption: 'All Venues',

    // NEW
    calendarOpenButtonLabel: "Calendar",
    shareButtonText: "Share",
    applyFiltersButtonText: "View Results",
    closeDialogButtonText: "Close Dialog",
    calendarNavigationHeading: "Change Date",
    shareLinkCopiedTooltip: "copied!",
    shareDateButtonText: "copy link to date",
    previousMonthButtonText: "Previous",
    nextMonthButtonText: "Next",
    todayButtonText: "Today",
    appliedPromoCodeHeading: "Applied promo code:",
    removePromoCodeButtonText: "Remove",
    scrollToTopButtonText: "Scroll to top",
    showShareButtons: true,
    souldOutText: ""
}